import { create } from 'zustand';
import { getState, useState } from '@/framework';
import type { IExportState, IMarkupDrawConfig, StateType } from '@/version-types';

/** 状态 */
interface IState {
    /** 绘制配置 */
    drawConfig: IMarkupDrawConfig | null;
}

/** 动作 */
interface IAction {
    /** 设置绘制配置 */
    setDrawConfig: (drawConfig: IMarkupDrawConfig | null) => void;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

/** 初始化状态 */
function getInitialState() {
    return {
        drawConfig: null,
    };
}

/** 创建存储 */
const createState = (identity: string) => {
    const store = create<IStore>((set, get) => ({
        ...getInitialState(),

        setDrawConfig(drawConfig) {
            set({ drawConfig });
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'markup-layer-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useMarkupLayerState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getMarkupLayerState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
